import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className="btn-icon-app focus-visible:outline-none"
      data-testid="theme-toggle"
    >
      {isDark ? (
        <Moon className="w-4 h-4" strokeWidth={1.5} aria-hidden="true" />
      ) : (
        <Sun className="w-4 h-4" strokeWidth={1.5} aria-hidden="true" />
      )}
    </button>
  );
};
